import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService, LocalStoreManager } from "../services";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, protected localStorage: LocalStoreManager, private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        console.log("Error2", err);
        if (err.status === 500 && err.error === null && err.statusText === "Internal Server Error") {
          console.log("statusText", err);
          this.logOute();
        }
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 503) {
            this.logOute();
          } else {
            try {
              const error =
                err.status === 500 && err.error === null
                  ? err.statusText
                  : err.error?.error?.message ||
                    err.error?.error?.statusText ||
                    err.error?.message ||
                    err.error?.statusText ||
                    err.error ||
                    err.statusText;

              console.log(error);
              if (
                (err.status === 500 && error.includes && error.includes("Internal Server Error")) ||
                (err.status === 200 && error.includes && error?.includes("Unexpected token")) ||
                error?.includes("The token is expired.") ||
                error?.includes("کاربر دیگری با همین نام کاربری وارد سیستم شده است.")
              ) {
                this.logOute();
              }
              return throwError(error);
            } catch (e) {
              console.log(e);
              return throwError(err);
            }
          }
        } else {
          if (err.status === 500 && err.statusText === "Internal Server Error") {
            console.log("statusText4", err);
            this.logOute();
          }
          return throwError(err);
        }
      })
    );
  }
  logOute() {
    console.log("logOute:");
    this.localStorage.deleteData(`TOKEN_${AuthService.loggingUserName}`);
    this.authService.logout();
    const findModal = document.getElementsByTagName("simple-modal-holder");
    for (let index = 0; index < findModal?.length; index++) {
      findModal[index].remove();
    }
    setTimeout(() => {
      const findModal2 = document.getElementsByTagName("simple-modal-wrapper");

      for (let index = 0; index < findModal2?.length; index++) {
        findModal2[index].remove();
      }
    }, 1000);
    this.router.navigate(["auth/login"]).then(() => {
      window.location.reload();
    });
  }
}
